import { render, staticRenderFns } from "./DownloadDocuments.vue?vue&type=template&id=77c3f1df"
import script from "./DownloadDocuments.vue?vue&type=script&lang=js"
export * from "./DownloadDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports